import React, { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import { GoogleCaptchaKey } from "../../../config/client-config";
import {
    InputText,
    InputTextArea
} from "../../../utils/dynamicForm";
import "../../../css/spaces-suggestions.css";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

const apiUrl = process.env.REACT_APP_BACKEND_URL || "not_set";
const RECAPTCHA_SITE_KEY = GoogleCaptchaKey;

function SuggestSpaceDetails({ t, spaceId }) {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        reset
    } = useForm();

    const [expanded, setExpanded] = useState(false);
    const [message, setMessage] = useState(null);
    const recaptchaRef = useRef(null);

    const accepted = watch("accepted");

    const onSubmit = async (data) => {
        try {
            const recaptchaToken = await recaptchaRef.current.executeAsync();

            const response = await fetch(`${apiUrl}/api/submit/suggestion`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    recaptchaToken,
                    data: {
                        ...data,
                        spaceId
                    }
                }),
            });

            if (response.ok) {
                setExpanded(false);
                const responseData = await response.json();
                setMessage(responseData.message || t("Suggestion submitted!"));
                toast.success(t("Thank you for your suggestion."));
                reset();
            } else {
                const errorData = await response.json();
                setMessage(errorData.message || t("An error occurred"));
                toast.error(t("Submission failed."));
            }
        } catch (err) {
            console.error("Suggestion error:", err);
            toast.error(t("Something went wrong. Please try again."));
        }
    };

    return (
        <div className="suggest-space-container">
            <ToastContainer />

            <button className="suggest-toggle-button" onClick={() => setExpanded(!expanded)}>
                {expanded ? t("Suggestion Form") : t("Make a Suggestion")}
            </button>

            <div className={`suggest-form-wrapper ${expanded ? "expanded" : ""}`}>
                <form onSubmit={handleSubmit(onSubmit)} className="suggest-form">
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        size="invisible"
                        sitekey={RECAPTCHA_SITE_KEY}
                    />

                    {InputText({
                        register,
                        errors,
                        placeholder: "",
                        label: `${t("Any contact information")} (${t("optional")})`,
                        name: "contact",
                        isRequired: false
                    })}

                    {InputText({
                        register,
                        errors,
                        placeholder: "",
                        label: `${t("Email")} (${t("optional")})`,
                        name: "email",
                        isRequired: false
                    })}

                    {InputTextArea({
                        register,
                        errors,
                        label: t("Suggested Changes"),
                        name: "suggestion_text_area",
                        isRequired: true
                    })}

                    <div className="suggest-space-disclaimer-text">
                        <p>
                            Τα στοιχεία που παρέχετε (όνομα, email κ.λπ.) χρησιμοποιούνται αποκλειστικά για την
                            καταγραφή της συνεισφοράς σας στην πλατφόρμα HeriScope και για την περίπτωση που χρειαστούν
                            διευκρινήσεις από την ομάδα που θα λάβει τις πληροφορίες σας.
                        </p>
                        <p>Τα δεδομένα σας δεν κοινοποιούνται σε τρίτους χωρίς τη συγκατάθεσή σας.</p>
                        <p>
                            Μπορείτε ανά πάσα στιγμή να ζητήσετε την τροποποίηση ή διαγραφή των δεδομένων σας
                            επικοινωνώντας μαζί μας στο <a href="mailto:heriscope@communitism.space">heriscope@communitism.space</a>.
                        </p>
                        <p>
                            ➡ Για περισσότερες πληροφορίες, δείτε την
                            <Link to='/privacy'> Πολιτική Απορρήτου </Link> μας.
                        </p>
                    </div>

                    <div className="form-checkbox">
                        <label>
                            <input type="checkbox" {...register("accepted", { required: true })} />
                            {" "}
                            {t("I have read and accept the data policy.")}
                        </label>
                        {errors.accepted && (
                            <span className="submit-error-validation">{t("You must accept before submitting.")}</span>
                        )}
                    </div>

                    {message && (
                        <p className={message.includes("Thank") ? "success-message" : "error-message"}>
                            {message}
                        </p>
                    )}

                    <div className="suggest-form-buttons">
                        <button type="button" className="cancel-button" onClick={() => setExpanded(false)}>
                            {t("Cancel")}
                        </button>
                        <input
                            type="submit"
                            className="submit-button"
                            value={t("Submit")}
                            disabled={!accepted}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
}

export default SuggestSpaceDetails;
